// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationFullControlPath = 'M26.5 0h47C79.299 0 84 4.701 84 10.5v79c0 5.799-4.701 10.5-10.5 10.5h-47C20.701 100 16 95.299 16 89.5v-79C16 4.701 20.701 0 26.5 0zm47 7H60.237l-3.817 5H43.58l-3.817-5H26.5a3.5 3.5 0 00-3.5 3.5v79a3.5 3.5 0 003.5 3.5h47a3.5 3.5 0 003.5-3.5v-79A3.5 3.5 0 0073.5 7zM55 84a5 5 0 11-10 0 5 5 0 0110 0zm-9.92-62.229l-4.8-3.602-5.454 7.264-2.945-2.944-4.242 4.242 7.834 7.835 9.606-12.795zm0 17l-4.8-3.602-5.454 7.264-2.945-2.944-4.242 4.242 7.834 7.835 9.606-12.795zm-4.8 13.398l4.8 3.602-9.607 12.795-7.834-7.835 4.242-4.242 2.945 2.944 5.455-7.264zM70.5 31.5v-7h-20v7h20zm-3 9v7h-17v-7h17zm3 23v-7h-20v7h20z';
var IllustrationFullControl = baseIllustration('IllustrationFullControl', {
  getPath: () => IllustrationFullControlPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationFullControl;
//# sourceMappingURL=index.js.map